import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "time-picker" }
const _hoisted_2 = ["readonly", "disabled", "placeholder"]
const _hoisted_3 = ["popovertarget", "disabled"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "controls hour-controls" }
const _hoisted_6 = { class: "value-label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "control-divider" }, ":", -1)
const _hoisted_8 = { class: "controls minute-controls" }
const _hoisted_9 = { class: "value-label" }

import Icon from "@common/components/Icon.vue";
import { Guid } from "@util/guid";
import _ from "lodash";
import moment, { Moment, unitOfTime } from "moment";
import { watch } from "vue";
import { computed, nextTick, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";

const DEFAULT_DATE_V_MODEL_FORMAT = "YYYY-MM-DD";
const DEFAULT_TIME_V_MODEL_FORMAT = "HH:mm";

//#region General
type ViewModel = { localValue: Moment | null };

export default /*#__PURE__*/_defineComponent({
  __name: 'MTimePicker',
  props: {
    value: {},
    buttonOnly: { type: Boolean },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    placeholder: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

console.debug("DEFAULT_DATE_V_MODEL_FORMAT: ", DEFAULT_DATE_V_MODEL_FORMAT);
const { d: $d } = useI18n();

const id = Guid.new();
const timePickerInput = ref<HTMLInputElement | null>(null);
const timePickerButton = ref<HTMLButtonElement | null>(null);
const timePickerMenu = ref<HTMLDivElement | null>(null);




//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ localValue: null });

const menuPosition = reactive({ x: 0, y: 0 });
const isOpen = ref(false);

//#endregion

//#region VisualContruction

const toggleHandler = (event: ToggleEvent) => {
  isOpen.value = event.newState == "open";
  calculatePositionOfMenu();
};

const calculatePositionOfMenu = () => {
  menuPosition.x = 0;
  menuPosition.y = 0;
  nextTick(() => {
    if (timePickerMenu.value && timePickerButton.value) {
      const toggleRect = timePickerButton.value.getBoundingClientRect();
      const menuRect = timePickerMenu.value.getBoundingClientRect();
      const x = toggleRect.x - menuRect.right + toggleRect.width;
      let y = toggleRect.y - menuRect.y + toggleRect.height;
      if (menuRect.bottom + y > window.innerHeight) {
        y = toggleRect.y - menuRect.bottom;
      }
      menuPosition.x = x;
      menuPosition.y = y;
    }
  });
};

//#endregion

//#region LocalValue

watch(
  () => props.value,
  (nv) => {
    if (!_.isEmpty(nv)) vm.localValue = moment(nv, DEFAULT_TIME_V_MODEL_FORMAT);
  },
  { immediate: true }
);

watch(
  () => vm.localValue,
  (nv) => {
    emits("input", nv?.format(DEFAULT_TIME_V_MODEL_FORMAT));
  },
  { deep: true }
);

const changeValue = (unit: unitOfTime.DurationConstructor, value: number) => {
  if (!vm.localValue) vm.localValue = moment().startOf("minutes");
  vm.localValue = moment(vm.localValue.add(value, unit));
  console.debug(vm.localValue?.format(DEFAULT_TIME_V_MODEL_FORMAT));
};

const inputValue = computed({
  get: () => {
    if (vm.localValue && vm.localValue.isValid()) {
      return $d(vm.localValue.toDate(), "shortTime");
    } else return "";
  },
  set: (nv) => {
    if (nv === "") vm.localValue = null;
    else {
      const parsed = moment(`${nv}`, DEFAULT_TIME_V_MODEL_FORMAT);
      if (parsed.isValid()) vm.localValue = parsed;
      else {
        if (timePickerInput.value) {
          timePickerInput.value.value = vm.localValue ? $d(vm.localValue.toDate(), "shortTime") : "";
        }
      }
    }
  }
});

//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.buttonOnly)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          ref_key: "timePickerInput",
          ref: timePickerInput,
          class: _normalizeClass(["time-picker-input", { 'read-only': _ctx.readonly, disabled: _ctx.disabled }]),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
          readonly: _ctx.readonly,
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder
        }, null, 10, _hoisted_2)), [
          [
            _vModelText,
            inputValue.value,
            void 0,
            { lazy: true }
          ]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: _normalizeClass(["time-picker-button", { disabled: _ctx.disabled }]),
      popovertarget: `time-picker-${_unref(id)}`,
      ref_key: "timePickerButton",
      ref: timePickerButton,
      disabled: _ctx.disabled
    }, [
      _createVNode(Icon, { icon: "Clock" })
    ], 10, _hoisted_3),
    _createElementVNode("div", {
      id: `time-picker-${_unref(id)}`,
      class: _normalizeClass(["time-picker-menu", { 'is-open': isOpen.value }]),
      popover: "",
      onToggle: toggleHandler,
      ref_key: "timePickerMenu",
      ref: timePickerMenu,
      style: _normalizeStyle({
        transform: `translate(${menuPosition.x}px, ${menuPosition.y}px)`
      })
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_b_btn, {
          class: "add-btn btn-icon mono",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeValue('hour', 1)))
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { icon: "ChevronTop" })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, _toDisplayString((vm.localValue ?? _unref(moment)()).format("HH")), 1),
        _createVNode(_component_b_btn, {
          class: "sub-btn btn-icon mono",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeValue('hour', -1)))
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { icon: "ChevronBottom" })
          ]),
          _: 1
        })
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_b_btn, {
          class: "add-btn btn-icon mono",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeValue('minute', 1)))
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { icon: "ChevronTop" })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, _toDisplayString((vm.localValue ?? _unref(moment)()).format("mm")), 1),
        _createVNode(_component_b_btn, {
          class: "sub-btn btn-icon mono",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeValue('minute', -1)))
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { icon: "ChevronBottom" })
          ]),
          _: 1
        })
      ])
    ], 46, _hoisted_4)
  ]))
}
}

})